<style lang="scss">
	#on-center1 {
		.ant-form-item-label {
			margin-top: 0rem;
		}
	}

	#handitemedit2_s {
		.ant-form-item{
			margin-bottom: 0;
		}
		
		.ant-row, .ant-calendar-picker{
			width: 100%;
		}

		// .ant-form-item-label {
		// 	width: 15% !important;
		// }

		.ant-form-item-control-wrapper {
			width: 100% !important;

			.wart-t {
				width: 100%;
			}
		}
		.ant-calendar-picker-input{
			width: 100%;
		}
		.myright{
			// .ant-form-item-label {
			// 	width: 34% !important;
			// 	padding-left: 5%;
			// }
		}
		.warp_long {
			width: 50%;
			display: inline-block;

			.ant-form-item-label {
				width: 100% !important;
			}

			.ant-form-item-control-wrapper {
				width: 100% !important;

			}
		}
		.formItem{
			.ant-form-item-children{
				display: flex;
				justify-content: space-between;
			}
			.ant-calendar-picker, .valinput{
				width: 45%;
			}
		}
		.texright {
			text-align: right;
			// margin-left: 4%;
		}
	}
	.ant-form-explain{
		display: none;
	}
</style>
<template>
	<div id='handitemedit2_s'>
		<div class="tabelMoreFzView main-mybody">
			<div class="tabelMoreFzViewIn">
				<a-form-model ref='ruleForm' :model="form" labelAlign='left' layout="vertical" :rules='rules'
					hideRequiredMark>
					<a-row type='flex' justify='space-between'>
						<a-col :span='24' class='myright' id='myright'>
							<a-form-model-item label="Stock Name" prop='stockname'>
								<a-input v-model="form.stockname" class='warp_width' 
								@input="form.stockname=form.stockname.replace(/[^a-z A-Z]/g,'')"
								  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'>
							<a-form-model-item label="Stock Code" :prop='form.status_cn!==0?"stockcode":""'>
								<a-input v-model="form.stockcode"  class='warp_width'
									 :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'>
							<a-form-model-item label='Listing Date' prop='listingdate'>
								<a-date-picker v-model="form.listingdate" type="date" @change="handback('listingdate')"
									:disabled-date="disabledDate" class='warp_width' placeholder=""  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'>
							<a-form-model-item label="Application Period" class="formItem" prop='application_begindate'>
								<a-date-picker class='dateinput' v-model='form.application_begindate' placeholder=""
								:disabled='ipoAduitAdmin'
									:disabled-date="disabledDate" @change="handback('application_begindate')">
									<template slot="dateRender" slot-scope="current, today">
										<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
											{{ current.date() }}
										</div>
									</template>
								</a-date-picker>
								<div class='warp_a'>~</div>
								<a-date-picker class='dateinput' v-model='form.application_enddate'
									:disabled-date="applicationDate" @change="handback('application_enddate')"
									:disabled='ipoAduitAdmin'
									placeholder="">
									<template slot="dateRender" slot-scope="current, today">
										<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
											{{ current.date() }}
										</div>
									</template>
								</a-date-picker>
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'>
							<a-form-model-item label="Offer Price" class="formItem" prop='offerprice_l'>
								<a-input v-model="form.offerprice_l" class='valinput'
									@blur='stockcodeFn("offerprice_l",1)'  :disabled='ipoAduitAdmin' />
								<div class='warp_a'>~</div>
								<a-input v-model="form.offerprice_h" class='valinput'
									@blur='stockcodeFn("offerprice_h",1)'  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'>
							<a-form-model-item label="Sponsor" prop='sponsor'>
								<!-- <Situationall v-model="form.baojianr" :url='$api.getParamList'
									:disabled='ipoAduitAdmin'
									:params='{"type":"baojianr"}' :val='form.baojianrval' :style='"width:100%;"'
									class='warp_rightz' :zz='"zz"'></Situationall> -->
									<Situationall v-model="form.sponsor"
										:url='$api.getParamList'
										:disabled='ipoAduitAdmin'
										:params='{"type":"sponsor"}'
										:valstr='JSON.parse(JSON.stringify(form)).baojianr_enval'
										:style='"width: 100%;"'>
									</Situationall>
									
								<a-popover :visible="visibles2" placement="top" trigger="click"
									:destroyTooltipOnHide="true" :overlayStyle="{width:'calc(25rem)'}"
									@visibleChange="moreEvent2()"
									:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
									<template slot="content">
										<div>
											<div id='on-center1'>
												<a-textarea v-model="form.sponsor"
													:auto-size="{ minRows: 4, maxRows: 5 }" @input="baofn"
													placeholder="Please use the semicolon ( ; ) for multiple sponsors" class='wart-t word-abc'  :disabled='ipoAduitAdmin' />
											</div>
										</div>
									</template>
									<img title='點擊添加更多' src="@/image/images.png" class='myupload' alt="">
								</a-popover>
							</a-form-model-item>
						</a-col>
						<a-col :span='11' class='myright'>
							<div id='on-center11'>
								<a-form-model-item label="Prospectus">
									<a-input v-model="form.prospectus" class='wart-t'  :disabled='ipoAduitAdmin' />
								</a-form-model-item>
							</div>
						</a-col>
					</a-row>
				</a-form-model>
			</div>
		</div>
		<div class='warp_daochu' style="justify-content: end;">
			<a-textarea v-model="form.remark" :auto-size="{ minRows: 3, maxRows: 5 }"
			:maxLength='200' :disabled-date="deliveryDate" class='wart-t'
			:disabled='ipoAduitAdmin'
			@input="form.remark=form.remark.replace(/[^a-z A-Z]/g,'')" 
			v-if="ipoAduitAdmin"
			/>
			<div style="display: flex;justify-content: center;align-items: center;" v-if="!ipoAduitAdmin">
				<button class='btn1 btnx' @click='savefn'>保存</button>
				<button class='btn1 btnx' style="background-color: #f48d28;" @click='gopagefn()'>提交審核</button>
			</div>
			<div style="display: flex;justify-content: center;align-items: center;" v-else>
				<button class='btn1 btnx' style="background-color: #ed4849;" @click='approvalClick(2)'>審批失敗</button>
				<button class='btn1 btnx' @click='approvalClick(1)'>審批成功</button>
			</div>
		</div>
	</div>
</template>

<script>
	import App from '@/assets/app.js';

	export default {
		props: ['record', 'forms','isopen'],
		data() {
			return {
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				visibles2: false,
				visibles1: false,
				rules: {
					stockcode: [{
						required: true,
						message: ' ',
						trigger: ['blur', 'change']
					}],
					stockname: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					stockname: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					offerprice_l: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					offerprice_h: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					pergshu: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					application_begindate: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					application_enddate: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					listingdate: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					entryfee: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_industry_name_cn: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					cn_planned_industry_name_en: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					cn_planned_company_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_company_name_en: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					status_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					plates_cn: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					delivery_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					baojianr: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					sponsor: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					anpantime: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					multiple: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					linkaddress: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					prospectus: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				
				england: 'cn',
				lang: {},
				admintypeArr: [{
					text: '處理中',
						entext:'Processing',
						value: '0'
					},
					{
						text: '認購中',
						entext:'Subscribing',
						value: '1'
					},
					{
						text: '待上市',
						entext:'Planned IPO',
						value: '2'
					},
					{
						text: '已上市',
						entext:'Listed IPO',
						value: '3'
					},
					{
						text: '已除牌',
						entext:'Delisted',
						value: '4'
					},
					{
						text: '已失效',
						entext:'Expired',
						value: '5'
					}	
				],
				admintypeArrs: [
					{
						text: '主板',
						entext: 'Mainboard',
						value: '0'
					},
					{
						text: '創業板',
						entext: 'GEM board',
						value: '1'
					},
				],
				moreFzOption: [],
				form: {
					stockname: '',
					stockcode: "",
					listingdate: "",
					application_begindate: "",
					application_enddate: "", 
					offerprice_l: '',
					offerprice_h: '',
					sponsor: '',
					prospectus:'',
					remark:''


					// "pricelist": [
					// 	{
					// 		"pricekey": "",
					// 		"priceval": ""
					// 	}, 
					// ],
					// info_en:'',
					// cn_planned_company_name_en: '', //公司名稱英文 
					// cn_planned_industry_name_en: '', //行業英文 
					// "stockname": "", //輸入股票名稱
					// "pergshu": '', //每手股數
					// "entryfee": '', //入場費
					// "cn_planned_company_name_cn": "", //公司名稱
					// "cn_planned_industry_name_cn": "", //上市行業
					// "status_cn": "", //上市狀態   已上市 （股票名称 股票代码）
					// "plates_cn": "", //上市板塊
					// "delivery_date": "", //遞表日期
					// "baojianr": "", //保薦機構
					// "anpantime": "", //暗盤時間
					// "multiple": '', //認購倍數
					// info: '',
					// linkaddress: '',
					// pricefileid: '',
					// loan_ratio: '', // 比率
					// loan_days: '', // 日數
					// gain: '', // 利息
					// // "adminid": "", // 錄入人唯一標識
				},
			}
		},
		mounted() {
			console.log(this.record.handle);
			let obj = JSON.parse(JSON.stringify(this.forms))
			obj.baojianr_enval = obj.sponsor
			obj.baojianrval = obj.baojianr
			this.form = JSON.parse(JSON.stringify(obj))
			this.lang = this.england == 'cn' ? this.$big5.sub : this.$eng.sub
		},
		methods: {
			savefn(){
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						this.$ajax({
							method:'post',
							url:this.$api.saveUsMarketStock,
							data:this.form
						}).then(res=>{
							if(res.data.qmiscode === 1000){
								App.oTool.successT(res.data.qmismsg)
								// this.$emit('child','save',res.data.id)
							}else{
								App.oTool.warningT(res.data.qmismsg)
							}
						})
					}
				})
			},
			gopagefn() {
				this.$refs.ruleForm.validate(valid => {
				if (valid) {
					this.$ajax({
						method:'post',
						url:this.$api.newUsMarketStock,
						data:this.form
					}).then(res=>{
						if(res.data.qmiscode === 1000){
							App.oTool.successT(res.data.qmismsg)
							this.$emit("child","handhome3")
						}else{
							App.oTool.warningT(res.data.qmismsg)
						}
					})
					}
				})
			},
			approvalClick(val){
				if (val == 1) {
					this.form.remark = "審批成功"
				}else{
					if (!this.form.remark) {
						App.oTool.warningT("請輸入審核內容")
						return
					}
				}
				this.$ajax({
					method:'post',
					url:this.$api.newUsMarketStock,
					data:{
						usstockid:this.form.usstockid,
						handle :val,  
						remark :this.form.remark,
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						App.oTool.successT(res.data.qmismsg)
					}else{
						App.oTool.warningT(res.data.qmismsg)
					}
				})
			},
			compareDate(dateTime1, dateTime2) {
				var formatDate1 = new Date(this.form[dateTime1])
				var formatDate2 = new Date(this.form[dateTime2])
				if (formatDate1 > formatDate2) {
					this.form[dateTime1] = '';
				}
			},
			handback(val) {
				this.form[val] = this.form[val] ? App.oDate.secsTime3(this.form[val]._d) : ''
				//（遞表日期）》啟示認購日期 》 終止認購日期》（上市日期）
				if (val == 'application_enddate' || val == 'application_begindate') {
					if (this.form.application_enddate && this.form.application_begindate) {
						this.compareDate('application_begindate', 'application_enddate')
					}
				}
				//遞表日期》上市日期
				if (val == 'delivery_date' || val == 'listingdate') {
					if (this.form.delivery_date && this.form.listingdate) {
						this.compareDate('delivery_date', 'listingdate')
						// anpantime
					}
				}
				//（遞表日期）》啟示認購日期
				if (val == 'delivery_date' || val == 'application_begindate') {
					if (this.form.delivery_date && this.form.application_begindate) {
						this.compareDate('delivery_date', 'application_begindate')
					}
				}
				//終止認購日期》（上市日期）
				if (val == 'application_enddate' || val == 'listingdate') {
					if (this.form.application_enddate && this.form.listingdate) {
						this.compareDate('application_enddate', 'listingdate')
					}
				}
			
			
				//暗盤日期 獲取上市日期前一天
				if (this.form.listingdate) {
					// this.form.anpantime = this.getNextDate(this.form.listingdate, -1)
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'application_enddate') {
					if (this.form.anpantime && this.form.application_enddate) {
						this.compareDate('application_enddate', 'anpantime')
					}
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'delivery_date') {
					if (this.form.anpantime && this.form.delivery_date) {
						this.compareDate('delivery_date', 'anpantime')
					}
				}
			},
			//彈出前操作
			moreEvent2() {
				this.visibles2 = !this.visibles2
				this.$set(this.form, 'baojianr_enval', JSON.parse(JSON.stringify(this.form.sponsor)))
			},
			moreEvent1() {
				this.visibles1 = !this.visibles1
				this.$set(this.form, 'baojianrval', JSON.parse(JSON.stringify(this.form.baojianr)))
			},
			//禁止選擇(大于)
			applicationDate(current) {
				return current && current > new Date(this.form.anpantime)
			},
			baofn() {
				this.form.baojianr = this.form.baojianr.replace(/[,]+/g, '')
			},
			//禁止選擇
			deliveryDate(current) {
				console.log( current > new Date(this.form.listingdate),current < new Date(this.form.delivery_date))
				return (current && current > new Date(this.form.listingdate))||(current &&current < new Date(this.form.delivery_date))
			},
			getCurrentStyle(current, today) {
				const style = {};
				if (current.date() === 1) {
					style.border = '1px solid #1890ff';
					style.borderRadius = '50%';
				}
				return style;
			},
			//禁止選擇(小于)
			disabledDate(current) {
				return current && current < new Date(this.getNextDate(this.form.delivery_date, 1))
			},
			addopen() {
				if (this.form.cn_planned_company_name_cn && (this.form.offerprice_h || this.form.offerprice_l)) {
					this.visibleadd = true
				} else {
					App.oTool.warningT(this.lang.pln + this.lang.comname + ',' + this.lang.price)
				}
			},
			// getdata(record = this.record) {
			// 	let _this = this;
			// 	let json = {
			// 		token: _this.$store.state.token,
			// 	}
			// 	https.fetchPost(apiUrl.getAdminRemarks, {
			// 		admintype: _this.forms.admintype,
			// 		token: json.token,
			// 		id: record.pdfcode,
			// 	}, json).then((data) => {
			// 		if (Object.is(data.qmiscode, 1000)) {
			// 			this.form.aduit = data.aduit;
			// 			this.form.ishanding = data.ishanding == '1' ? true : false;
			// 			this.form.shShowBol = true;
			// 			this.form.shKhadmin1Bol = (record.ishanding && _this.forms.admintype == 'khadmin1') && !(
			// 				record.schedule == 1 && record.status == 1);
			// 		} else {
			// 			App.oTool.warningT(data.qmismsg);
			// 		}
			// 	}).catch(err => {
			// 		console.log(err);
			// 	});
			// },
			stockcodeFn(value, zero) {
				this.form[value] = App.isnumdate(this.form[value], zero)
				if (this.form.offerprice_l && this.form.offerprice_h) {
					if (this.form.offerprice_l * 1 > this.form.offerprice_h * 1) {
						let num = this.form.offerprice_h
						this.form.offerprice_h = this.form.offerprice_l
						console.log(num)
						this.form.offerprice_l = num
					}
				}
			},
			//前后一天
			getNextDate(date, day) {
				var dd = new Date(date);
				dd.setDate(dd.getDate() + day);
				var y = dd.getFullYear();
				var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
				var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
				return y + "-" + m + "-" + d;
			},
		}
	}
</script>

<style>
	.myupload{
		z-index:1111;cursor: pointer;
			position: absolute;right: 0.5rem;width: .7rem;top: 0.2rem;
	}
	@media screen and (min-width:1924px){
		.myupload{
			top: 0.45rem;
			right: 0.8rem;
		}
	}
</style>
